import { Component } from "react";
import { withRouter } from "../../utils/withRouter";
import { Layout, Button, Menu } from "antd";
import {
  HomeOutlined,
  AppstoreOutlined,
  PlusOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import mainStyles from "../../styles/Main.module.css";
import { getSession, deleteSession, getBricksForOrganization } from "../../utils";
import OrganizationBrickCollections from "./OrganizationBrickCollections";
import CreateCollectionModal from "./CreateCollectionModal";

const { Header, Sider, Content } = Layout;

interface State {
  session: any;
  brickCollections: any[] | null;
  createCollectionModal: boolean;
}

class Dashboard extends Component<any, State> {
  state: State = {
    session: null,
    brickCollections: null,
    createCollectionModal: false,
  };

  componentDidMount() {
    const userSession = getSession();
    this.fetchBricks();
    this.setState({
      session: userSession,
    });
  }

  fetchBricks = async () => {
    const brickCollections = await getBricksForOrganization(
      this.props.match.params.organizationId
    );
    this.setState({
      brickCollections,
    });
  };

  /**
   * Log user out by clearing cookie and redirecting
   */
  logout = () => {
    deleteSession();
    this.props.history.push(`/login`);
  };

  render() {
    return (
      <Layout className={mainStyles.main}>
        <Sider className={mainStyles.mainSider} width={200}>
          <div className={mainStyles.siderLogo}>Brixture</div>
          <Menu
            theme="dark"
            mode="inline"
            selectedKeys={["collections"]}
            items={[
              {
                key: "home",
                icon: <HomeOutlined />,
                label: "Organizations",
                onClick: () => this.props.history.push("/"),
              },
              {
                key: "collections",
                icon: <AppstoreOutlined />,
                label: "Collections",
              },
            ]}
          />
        </Sider>
        <Layout>
          <Header className={mainStyles.mainHeader}>
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <Button
                type="text"
                icon={<ArrowLeftOutlined />}
                onClick={() => this.props.history.push("/")}
              />
              <span className={mainStyles.headerTitle}>Brick Collections</span>
            </div>
            <div className={mainStyles.headerActions}>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => this.setState({ createCollectionModal: true })}
              >
                Nieuwe Collectie
              </Button>
            </div>
          </Header>
          <Content className={mainStyles.container}>
            <OrganizationBrickCollections
              brickCollections={this.state.brickCollections}
            />
          </Content>
        </Layout>
        <CreateCollectionModal
          open={this.state.createCollectionModal}
          onClose={() => {
            this.fetchBricks();
            this.setState({ createCollectionModal: false });
          }}
        />
      </Layout>
    );
  }
}

export default withRouter(Dashboard);
